import { $config } from '@client/core/atoms/config.js';
import { Brand, PageType, Vertical } from '@schibsted-nmp/advertising-shared';

export const isFinnTravelObjectPage = (): boolean => {
  const { pageType, brand, vertical } = $config.get() ?? {};

  const isFinn = brand === Brand.Finn;
  const isTravel = vertical === Vertical.Travel;
  const isObject = pageType === PageType.Object;
  return isFinn && isTravel && isObject;
};
